import { render, staticRenderFns } from "./WEBMAINCONFIGU.vue?vue&type=template&id=1b1b2f97"
import script from "./WEBMAINCONFIGU.vue?vue&type=script&lang=js"
export * from "./WEBMAINCONFIGU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports